
import * as OM from '@/model';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { BaseUserClient, DeferredPaymentClient } from '@/services/Services';
import { Prop, Watch } from "vue-property-decorator";
import store from '@/store';

@Options({})
export default class completeOfferForm extends Vue {

    @Prop() offer: OM.ShopOffer;
    @Prop() cart: OM.ShoppingCart;

    isFormOk: boolean = false;

    created(){
    }

    @Watch('cart.formAnswers', { deep: true })
    onCartChange(){
        this.isFormOk = this.checkForm();
    }

    checkForm(){
        if(!this.offer.useBuyForm)
            return true;

        let res = true;
        this.offer.formItems.forEach(x => {
            if(x.required){
                if(!this.cart.formAnswers[x.name]){
                    res = false;
                }
            }
        })

        return res;
    }

}
